export const gallery = [
    {
        img: 'https://cdna.artstation.com/p/assets/images/images/067/572/176/large/lazaro-vinicius-northon-final.jpg?1695693837',
        title: 'Northon de Ultrajante',
        href: 'https://www.artstation.com/artwork/1xOzLZ',
        alt: 'Arte de carregamento de personagem do jogo Ultrajante',
    },
    {
        img: 'https://cdna.artstation.com/p/assets/images/images/067/137/762/large/lazaro-vinicius-marry-final.jpg?1694631730',
        title: 'Marry de Ultrajante',
        href: 'https://www.artstation.com/artwork/lDXmqz',
        alt: 'Arte de carregamento de personagem do jogo Ultrajante',
    },
    {
        img: 'https://cdna.artstation.com/p/assets/images/images/053/821/954/large/lazaro-vinicius-rasputin-splashart.jpg?1694633649',
        title: 'Rasputin de Ultrajante',
        href: 'https://www.artstation.com/artwork/2qe05A',
        alt: 'Arte de carregamento de personagem do jogo Ultrajante',
    },
    {
        img: 'https://cdna.artstation.com/p/assets/images/images/053/054/230/small/lazaro-santos-cebollurl-splashart.jpg?1661310274',
        title: 'Cebollurl de Ultrajante',
        href: 'https://www.artstation.com/community/projects/Pex9n1/edit',
        alt: 'Arte de carregamento de personagem do jogo Ultrajante',
    },
    {
        img: 'https://i.imgur.com/lRCf3pY.png',
        title: 'Concept Art de Rose',
        href: 'https://www.instagram.com/p/CLuu6bOlGJQ/?img_index=1',
        alt: 'Desenho de personagem protagonista de Sewers Crumble',
    },
    {
        img: 'https://i.imgur.com/IeyySCe.png',
        title: '300',
        href: 'https://www.instagram.com/p/CJwrEAoFmNi/?img_index=1',
        alt: 'Desenho sobre o filme 300 (2006) de Zack Snyder',
    }    
]